module.exports = __webpack_public_path__ + "static/media/main.df63e480.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/main.jpg
// module id = 112
// module chunks = 0